<div [class]="chipType" id="common-chip-wrapper" [ngStyle]="customStylingOfChipContainer" (click)="onChipClick()">
  <!-- AVATAR -->
  <app-icon id="common-chip-icon-id" class="common-chip-icon" [name]="avatarName" [size]="avatarSize"
    *ngIf="showAvatar" [color]="avatarColor">
  </app-icon>

  <!-- LABEL TEXT  -->
  <app-text id="common-chip-text-id">
    <ng-content></ng-content>
  </app-text>

  <!-- TRAILING ICON  -->
  <app-icon id="common-chip-icon-id" class="common-chip-icon" [name]="iconName" [size]="iconSize" *ngIf="showIcon">
  </app-icon>
</div>